/**
 * Every path this app asks for, relative to the namespace `http` is pinned to. A leading
 * `/` here is a resource of **that** namespace and nothing else; the host is never named,
 * and a path that would have to climb out of it does not belong in this map.
 */
export const API = {
  adnetworks: '/adnetworks',
  adnetworkCredentials: '/adnetwork_credentials',
  adnetworkZones: '/adnetwork_zones',
  trafficSourcePresetAssignments: '/traffic_source_preset_assignments',
  trafficSources: '/traffic_sources',
  trafficRules: '/traffic_rules',
  trafficSourceCredentials: '/traffic_source_credentials',
  trafficCreatureBlockers: '/traffic_creature_blockers',
  websites: '/websites',
  mediaKits: '/media_kits',
  placements: '/placements',
  flatDeals: '/flat_deals',
  flatDealHistory: '/flat_deals/history',
  creatives: '/creatives',
  masterSpots: '/master_spots',
  masterSpotSets: '/master_spot_sets',
  masterSpotSetSpots: '/master_spot_set_spots',
  spots: '/spots',
  publisherTrafficSources: '/publisher_traffic_sources',
  rtbSources: '/rtb_sources',
  sourceRestrictions: '/source_restrictions',
  userViolationBlocker: '/user_violation_blocker',
  faqs: '/faqs',
  antiAdblockDomains: '/anti_adblock_domains',
  antiAdblockDomainsMeta: '/anti_adblock_domains/meta',
  malwareScans: '/malware_scans',
  malwareScansMeta: '/malware_scans/meta',
  malwareTasks: '/malware_tasks',
  malwareBlockers: '/malware_blockers',
  malwareViolationGroups: '/malware_violation_groups',
  aabDomainChecks: '/aab_domain_checks',
  subidMacroGaps: '/subid_macro_gaps',
  countries: '/countries',
  contact: '/contact',
  paymentProfiles: '/payment_profiles',
  userVerification: '/user_verification',
  apiAccess: '/api_access',
  password: '/password',
  twoFactor: '/two_factor',
  telegramAccount: '/telegram_account',
  userWebhooks: '/user_webhooks',
  widgets: '/widgets',
  reportMeta: '/reports/meta',
  balance: '/balance',
  withdrawalRequests: '/withdrawal_requests',
  withdrawalOption: '/withdrawal_option',
  paymentMethods: '/payment_methods',
  paypalOrders: '/paypal_orders',
  paymentSystems: '/payment_systems',
  replenishmentMethods: '/replenishment_methods',
  replenishments: '/replenishments',
  transactions: '/transactions',
  marketingPosts: '/marketing_posts',
  search: '/search',
  registration: '/registration',
  passwordRecovery: '/password_recovery',
  emailConfirmation: '/email_confirmation',
  subscription: '/subscription',
  session: '/session',
  sessionSocial: '/session/social',
  sessionBecome: '/session/become',
  sessionGetBack: '/session/get_back',
  account: '/account',
  accountRequestCall: '/account/request_call',
  accountRequestMarketplace: '/account/request_marketplace',
  accountAcceptTerms: '/account/accept_terms',
  accountSystemMessage: '/account/system_message',
  adminUserNotes: '/admin/user_notes',
  adminToggleFrozen: '/admin/toggle_frozen',
  adminTogglePayments: '/admin/toggle_payments'
} as const
